import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import moment from 'moment'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'

import Clickable from 'components/Common/Clickable'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { AutoTooltipContent } from 'components/Common/AutoTooltip'
import cn from 'clsx'
import Breakpoint from 'components/Common/Breakpoint'
import Caption from 'components/Luxkit/Typography/Caption'

const Root = styled(Clickable)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: ${rem(48)};
  border-radius: ${props => props.theme.borderRadius.small};
  position: relative;
  width: 100%;
  background: ${props => props.theme.palette.neutral.eight};

  &.error {
    background: ${props => props.theme.palette.messaging.critical.light};
    border: none;
  }
`

const InputWrapper = styled.div`
  flex: 1;
  text-align: left;
`

const DateInputToogle = styled.div`
  border: 1px solid ${props => props.theme.palette.neutral.five};
  padding: 0 ${rem(16)};
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${rem(48)};
  flex: 1;

  &.error {
    background: ${props => props.theme.palette.messaging.critical.light};
    border: 1px solid ${props => props.theme.palette.messaging.critical.main};
  }
`

const CheckinDateToogle = styled(DateInputToogle)`
  border-top-left-radius: ${props => props.theme.borderRadius.small};
  border-bottom-left-radius: ${props => props.theme.borderRadius.small};
  border-right: none;

  &.error {
    border-right: none;
  }
`
const CheckoutDateToogle = styled(DateInputToogle)`
  border-top-right-radius: ${props => props.theme.borderRadius.small};
  border-bottom-right-radius: ${props => props.theme.borderRadius.small};
`

interface Props {
  className?: string;
  checkinDate?: moment.Moment;
  checkoutDate?: moment.Moment;
  openMenu: () => void;
  showTravelDatesError?: boolean;
}

function DualDateSelectToggle(props: Props) {
  const { className, checkinDate, checkoutDate, openMenu, showTravelDatesError } = props
  const errorMessage = 'Please select travel dates'
  const checkinDateError = !checkinDate && showTravelDatesError
  const checkoutDateError = !checkoutDate && showTravelDatesError

  return (
    <Root onClick={openMenu}>
      <CheckinDateToogle className={cn(className, { error: checkinDateError })}>
        <InputWrapper>
          <Caption variant="large" weight="bold">Departing</Caption>
          <BodyText colour={!checkinDate ? 'neutral-two' : undefined} variant="medium">
            {checkinDate ? moment(checkinDate).format(DMY_CASUAL_FORMAT) : 'Select date'}
          </BodyText>
        </InputWrapper>
      </CheckinDateToogle>
      <CheckoutDateToogle className={cn(className, { error: checkoutDateError })}>
        <InputWrapper >
          <Caption variant="large" weight="bold">Returning</Caption>
          <BodyText colour={!checkoutDate ? 'neutral-two' : undefined} variant="medium">
            {checkoutDate ? moment(checkoutDate).format(DMY_CASUAL_FORMAT) : 'Select date'}
          </BodyText>
        </InputWrapper>
      </CheckoutDateToogle>
      <Breakpoint min="lg">
        <AutoTooltipContent
          open={showTravelDatesError}
          position="above-left"
          alignment="left"
          type="error"
        >
          {errorMessage}
        </AutoTooltipContent>
      </Breakpoint>
    </Root>
  )
}

export default DualDateSelectToggle
